export default __webpack_public_path__ + "static/media/Snd_LowerGMagicC.80f994f2.mp3";